<template>
	<MainLayout>
		<div id="zoned-area-editor" class="container">
			<div class="box">
				<b-alert
					class="p-3 text-center"
					variant="success"
					dismissible
					fade
					:show="clone.zonedArea.id>0"
					>
					<b >Se Generó correctamente:</b>
					<a v-if="!$root.isEmpty(linkToClonedArea)" :href="linkToClonedArea" v-b-tooltip.hover title="Ir a configurar la nueva zona" target="_blank" >
						[{{ clone.zonedArea.id }}] {{ clone.zonedArea.name }} <md-icon icon="link" class="__shake"/>
					</a>
				</b-alert>
				<div>
					<b-jumbotron class="p-2 mb-0" bg-variant="light">
						<template #header>
							<h3>Editando : <b>[{{zonedArea.id}}] {{zonedArea.name}} <md-icon class="text-info" icon="beenhere" v-if="zonedArea.masterArea"/></b></h3>
						</template>
						<b-row class="mt-4">
							<b-col>
								<b-button variant="outline-dark" @click="openDetails" >¿Donde se usa?</b-button>
								<b-button v-if="$hasPermission('zoneArea.export')" @click="exportExcel('csv')" variant="outline-dark" class="ml-2">Descargar CSV</b-button>
								<b-button v-if="$hasPermission('zoneArea.export')" @click="exportExcel('kml')" variant="outline-dark" class="ml-2">Descargar KML</b-button>
								<b-button @click="openDuplicate" v-if="$hasPermission('zoneArea.edit')"  variant="outline-dark" class="ml-2" v-b-tooltip.hover title="Generar un nuevo registro con la misma distribución de zonas">
									Duplicar Poligonos
									<md-icon :icon="'content_copy'" />
								</b-button>
							</b-col>

						</b-row>
						<hr class="my-3">
					</b-jumbotron>

				</div>


				<div style="position: relative;">
					<b-overlay :show="loading" no-wrap ></b-overlay>
					<MapZones
						v-if="zonedArea && zonedArea.zonesType=='polygon' "
						:zoned-area="zonedArea"
						@reFetch="fetchModel()"
					/>
					<PostalCodesZones
						v-if="zonedArea && zonedArea.zonesType=='postalCode' "
						:zoned-area="zonedArea"
						@reFetch="fetchModel()"
					/>
				</div>
			</div>
		</div>

		<SingleResumeZonedArea v-model="showResumeModule" ref="single-resume" />
		<b-modal id="modal-confirmation-duplicate" title="Confirmación de acción" @ok="handleOkDuplicate" ref="modal-copy-zone">
			<b-overlay :show="clone.loading" no-wrap ></b-overlay>
			<h5 class="">¿Confirmas tu decisión de realizar esta acción?</h5>
			<p>Esta acción no afectará de ninguna manera la zona de operación actual, unicamente se generará un registro nuevo con la misma distribución</p>
			<hr>
			<section>
				<b>En caso de continuar escriba el nombre de la nueva distribución de zonas:</b>
				<b-input v-model="clone.newName"></b-input>
			</section>
		</b-modal>
	</MainLayout>
</template>

<script>
import MapZones from './MapZones'
import PostalCodesZones from './PostalCodesZones'
import MainLayout from '../layout/MainLayout'
import SingleResumeZonedArea from "./Resume/Single.vue"

export default {
		components: { MainLayout, MapZones, PostalCodesZones, SingleResumeZonedArea },
		data(){
			let id = parseInt(this.$root.getParams().id)
			return {
				loading : true,
				zonedAreaId : id,
				zonedArea:  {id:-1,name:""},
				firstFetch:true,
				showResumeModule:false,
				loadingExport:false,
				clone:{
					loading:false,
					newName:"",
					zonedArea:{id:-1,name:""},
				}
			}
		},
		computed : {
			downloadFormatURL() {
                return `${process.env.VUE_APP_API_URL}/zoned-areas/${this.zonedAreaId}/export`
            },
			linkToClonedArea(){
				if(this.clone.zonedArea.id>0) return `/zoned-areas-edit?id=${this.clone.zonedArea.id}`;
				return "";
			}
		},
		methods:{
			exportExcel(type = 'csv') {
				this.loadingExport = true;
				this.$root.api
					.get(`zoned-areas/${this.zonedAreaId}/export`, { params: { type } })
					.then(res => {
						if (type === 'kml') {
							const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.google-earth.kml+xml' }))
							const fileLink = document.createElement('a')
							fileLink.href = fileURL
							fileLink.setAttribute('download', 'Zonas.kml')
							document.body.appendChild(fileLink)
							fileLink.click()
							window.URL.revokeObjectURL(fileURL)
						} else {
							this.$root.downloadCsv(res, "Zonas");
						}
					})
					.catch(err => {
						this.$root.handleRequestError(err);
					})
					.finally(() => {
						this.loadingExport = false;
					});
			},
			fetchModel(){
				this.loading = true
				this.$root.api.get(`/zoned-areas/${this.zonedAreaId}`).then( res => {
					this.zonedArea = {...res.data}
					this.loading = false
				}).catch(this.$root.handleRequestError);
			},
			openDetails(){
				this.showResumeModule = true;
				this.$refs['single-resume'].loadModel(this.zonedAreaId)
			},
			openDuplicate(){
				this.clone.newName = this.zonedArea.name+" Copy";
				setTimeout(() => {
					this.$refs['modal-copy-zone'].show();
				},0);
			},
			handleOkDuplicate(ev){
				ev.preventDefault();
				this.clone.loading = true
				this.$root.api.post(`/zoned-areas/${this.zonedAreaId}/actions/duplicate`,{newName:this.clone.newName}).then( res => {
					this.clone.zonedArea = res.data;
					setTimeout(() => {
						this.$refs['modal-copy-zone'].hide();
					}, 0);
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.clone.loading= false;
				})
			}
		},
		mounted(){
			this.fetchModel()
		}
}
</script>

<style scoped>
	#search-box {
		width: 100%;
		max-width: 400px;
		padding: 5px;
		font-size: 16px;
	}
	.zone-button {
		flex: 1;
	}
	.input-groups {
		width: 100%;
	}
</style>
<style >
	#zoned-area-editor .card-body{
		background: #021D3E !important;
		color: white;
	}
	#zones-map{
		width: 100%;
		height: 500px;
	}
</style>
